import { render, staticRenderFns } from "./pghome.vue?vue&type=template&id=1615df0e&"
import script from "./pghome.vue?vue&type=script&lang=js&"
export * from "./pghome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports